import { EObjectTypeActions } from '../../constants/actionTypes/objectType';
import { EObjectType } from '../../constants/objectType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setObjectType = actionGenerator<EObjectTypeActions.setObjectType, EObjectType>(
  EObjectTypeActions.setObjectType,
);

export type TSetObjectTypeAction = ReturnType<typeof setObjectType>;

export type TObjectTypeActions = TSetObjectTypeAction;
